import { Button, createStyles, IconButton, makeStyles, Theme, Tooltip, Typography } from "@material-ui/core";
import * as React from "react";
import { GamePlayer, LetterGuessState, SocketMessageType } from "../../../../Definitions/Definitions";
import { useGameContext } from "../../../GameContext/GameContext";
import { getOriginalGamePowerupImageName, OriginalGameState } from "../../../GameContext/OriginalGameState";
import { useWindowDimensions } from "../../UseWindowDimensions";
import { LetterGrid } from "../LetterGrid";
import VisibilityIcon from '@material-ui/icons/Visibility';

interface Props {
    player: GamePlayer;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
            gap: "0.5rem"
        },
        opponentContent: {
            maxWidth: "max-content",
            overflow: "hidden",
            position: "relative"
        },
        opponentName: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        powerupOverlay: {
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            animation: `$powerupEffect 1500ms ${theme.transitions.easing.easeInOut}`,
            opacity: 0,
            backgroundColor: "#b7b4aeff",
            padding: "3px",
            borderRadius: "20px",
            width: "32px",
            height: "32px"
        },
        "@keyframes powerupEffect": {
            "0%": {
                opacity: 0,
                width: "32px",
                height: "32px"
            },
            "30%": {
                opacity: 1,
            },
            "50%": {

            },
            "100%": {
                opacity: 0,
                width: "50px",
                height: "50px"
            }
        }
    })
);

export const OriginalGameOpponentRow = (props: Props) => {
    const classes = useStyles();
    const { width, height } = useWindowDimensions();
    const gameContext = useGameContext();

    const { playerStateList, gameParameters, opponentPowerups, actualLocalPlayer } = gameContext.gameState as OriginalGameState;
    const { player } = props;

    const isPlayerValid = player.id in playerStateList && !(playerStateList[player.id].wordIndex == 0 && playerStateList[player.id].guessCount == 0);

    const getPlayerWordsCompleted = () => {
        if (isPlayerValid) {
            let wordComplete = true;
            playerStateList[player.id].matches.forEach((m) => { if (m != LetterGuessState.Match) wordComplete = false; })

            if (playerStateList[player.id].guessCount == gameParameters.guessCount) wordComplete = true;

            // if the player has all matches or all guesses, show that the word was completed before
            // they move on to the next word by adding one to the word index
            return playerStateList[player.id].wordIndex + (wordComplete ? 1 : 0);

            //return playerStateList[player.id].wordIndex;
        }
        return 0;
    }

    const spectate = () => {
        gameContext.sendMessage(SocketMessageType.SpectatePlayer, player.id);
    }

    const getNameFontSize = () => {
        if (width < 600) {
            if (player.name.length > 7) return 10;
        } else {
            if (player.name.length > 14) return 12;
            if (player.name.length > 10) return 14;
        }

        return "";
    }

    return (
        <div className={classes.root}>
            <div className={classes.opponentContent}>
                <div className={classes.opponentName}>
                    <Typography variant="body1" style={{ fontSize: getNameFontSize() }}>{player.name.substr(0, width < 600 ? 9 : 15)}</Typography>
                    {
                        <Typography variant="body1" color="textSecondary">
                            {`${getPlayerWordsCompleted()}${width < 600 ? "" : "/"}${width < 600 ? "" : gameParameters.wordCount}`}
                        </Typography>
                    }
                </div>
                <LetterGrid
                    rows={1}
                    cols={gameParameters.wordLength}
                    words={isPlayerValid ? ["     "] : []}
                    matches={isPlayerValid ? [playerStateList[player.id].matches] : []}
                    size="sm"
                />
                {
                    opponentPowerups.map((p, i) => {
                        if (p.playerId != player.id) return;

                        return (
                            <div key={p.id} className={classes.powerupOverlay}>
                                <img src={`images/powerups/${getOriginalGamePowerupImageName(p.powerup)}`} width={"100%"} height={"100%"} />
                            </div>
                        )
                    })
                }
            </div>
            {actualLocalPlayer?.isSpectator &&
                <Tooltip title={<Typography variant="body1">Spectate {player.name}</Typography>}>
                    <IconButton onClick={spectate} style={{ padding: "5px" }}>
                        <VisibilityIcon fontSize={width < 600 ? "small" : "large"} color="secondary" />
                    </IconButton>
                </Tooltip>
            }
        </div>
    );
}